import React, { useMemo, useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { InputAdornment, TextField, Typography, withStyles } from '@material-ui/core';
import { hasPermission, parseURL } from '../../sc-utilities';
import ProductOverviewList from './ProductOverviewList';
import { listStyle, getModel, getFormatWipeStarted, imeisAndSerialNumber, isNumeric } from './utils';
import Clear from "@material-ui/icons/Clear";

const styles = theme => ({
    ...listStyle,
    clearInputIcon: {
        cursor: 'pointer'
    }
});

export const getGroupsLookup = (groups, translations, permissions) => {
    if (!(groups instanceof Array)) {
        return {};
    }
    let groupsLookup = groups?.reduce((acc, item) => {
        acc[item.GroupID] = item.Name;
        return acc;
    }, {});

    const hasAccessAllGroupsPermission = hasPermission(permissions, 'access_all_groups');
    const allGroupsLookup = hasAccessAllGroupsPermission ? { 'n/a': translations['short_not_assigned'] || 'n/a', ...groupsLookup } : groupsLookup;
    return allGroupsLookup;
}

export const getSecurazeSolution = (rowData) => {
    if (rowData.Components && rowData.Components.length > 0) {
        const component = rowData.Components[0];
        if (component && component.StorageComponents && component.StorageComponents.length > 0) {
            const storage = component.StorageComponents[0];
            if (storage && storage.Solution) {
                return storage.Solution.LongName;
            } else if (storage) {
                return storage.SecurazeSolution;
            }
        } else if (component && component.StorageComponents) {
            const storage = component.StorageComponents;
            if (storage && storage.Solution) {
                return storage.Solution.LongName;
            } else if (storage) {
                return storage.SecurazeSolution;
            }
        }
    }
    if (rowData.StorageComponents && rowData.StorageComponents.length > 0) {
        const storage = rowData.StorageComponents[0];
        if (storage && storage.Solution) {
            return storage.Solution.LongName;
        } else if (storage) {
            return storage.SecurazeSolution;
        }
    } else if (rowData.StorageComponents) {
        const storage = rowData.StorageComponents;
        if (storage && storage.Solution) {
            return storage.Solution.LongName;
        } else if (storage) {
            return storage.SecurazeSolution;
        }
    }
    return "";
}


export const getSecurazeStandard = (rowData) => {
    if (rowData.Components && rowData.Components.length > 0) {
        const component = rowData.Components[0];
        if (component && component.StorageComponents && component.StorageComponents.length > 0) {
            const storage = component.StorageComponents[0];
            if (storage && storage.Standard) {
                return storage.Standard.LongName;
            } else if (storage) {
                return storage.WipeMethod;
            }
        } else if (component && component.StorageComponents) {
            const storage = component.StorageComponents;
            if (storage && storage.Standard) {
                return storage.Standard.LongName;
            } else if (storage) {
                return storage.WipeMethod;
            }
        }
    }
    if (rowData.StorageComponents && rowData.StorageComponents.length > 0) {
        const storage = rowData.StorageComponents[0];
        if (storage && storage.Standard) {
            return storage.Standard.LongName;
        } else if (storage) {
            return storage.WipeMethod;
        }
    } else if (rowData.StorageComponents) {
        const storage = rowData.StorageComponents;
        if (storage && storage.Standard) {
            return storage.Standard.LongName;
        } else if (storage) {
            return storage.WipeMethod;
        }
    }
    return "";
}

const ProductsAll = props => {
    const { classes, wipeStatusLookup, verificationStatusLookup, hideViewSelector, productTypeLookup, translations, currentView, updateView, permissions, method, createPaletteAction, getStorageComponentData, createPaletteActionForProduct, createAction, tableRef, redirectOptions, groupsLookup = {}, groups } = props;

    let filterValues = useRef({});

    const focusedInputRef = useRef();

    const [query, setQuery] = useState(null);

    useEffect(() => {
        if (hideViewSelector) {

            let myQuery = parseURL(window.location.href);
            myQuery && setQuery(myQuery);
        }
        // eslint-disable-next-line
    }, [setQuery, tableRef]);

    useEffect(() => {
        filterValues.current = {};
    }, [currentView])

    let tableColumns = useMemo(() => {
        const columns = tableRef?.current?.state?.columns ?? [];

        let cols = columns.map(el => el?.field);

        if (query) {
            query['q'] = {};

            for (let property in query) {
                if (isNumeric(query[property])) {
                    (query[property]) = +query[property];
                }

                if (typeof query[property] === 'string' && query[property].includes(',')) {
                    query[property].split(',');
                    query[property] = query[property].split(',');
                }

                if ((property === 'ProductType' || property === 'WipeStatus' || property === 'VerificationStatus' || property === 'WipeMethod') && typeof query[property] === 'string') {
                    query[property] = [query[property]]
                }

                if (cols && cols.includes(property)) {
                    query['q'] = { ...query.q }
                    query.q[property] = query[property];
                    delete query.property;
                }

                delete query['filters'];
            };

        };

        const filter = (value) => {
            if (columns) {
                let index = columns.findIndex(column => column.field === value);
                if (index !== -1) {
                    return columns[index];
                }
            }
        };
        const direction = (tableRef?.current?.dataManager?.orderDirection !== '' || tableRef?.current?.dataManager?.orderDirection === 'asc' || tableRef?.current?.dataManager?.orderDirection === 'desc' ? tableRef?.current?.dataManager?.orderDirection : undefined);

        const customFilter = ({ columnDef, onFilterChanged }) => {
            const columnId = columnDef.tableData.id;

            const fieldName = tableRef?.current?.props?.columns[columnId]?.field;
            const inputValue = columnDef.tableData.filterValue;

            return <TextField
                id={fieldName}
                onFocus={() => focusedInputRef.current = fieldName}
                onBlur={() => focusedInputRef.current = null}
                value={inputValue || ""}
                onChange={(e) => {
                    const filterValue = e.target.value;
                    if (filterValues) {
                        filterValues.current = ({ ...filterValues.current, fromEnter: false, refetch: true, q: { ...filterValues.current?.q, [fieldName]: filterValue } });
                    }
                    onFilterChanged(columnId, filterValue);
                }}
                InputProps={{
                    endAdornment: inputValue &&
                        <InputAdornment
                            position="start"
                            className={classes.clearInputIcon}
                            onClick={() => {
                                let updatedQ = filterValues.current?.q;
                                updatedQ[fieldName] = null;
                                // filterValues.current = ({...filterValues.current, fromEnter: true, refetch: true, q: updatedQ});
                                onFilterChanged(columnId, null);
                                // tableRef.current && tableRef.current.onQueryChange();
                            }
                            }
                        >
                            <Clear />
                        </InputAdornment>,
                }}
            />
        }

        return [
            {
                title: translations["action"] || 'Action', field: 'Action', filtering: false, cellStyle: { minWidth: 150, maxWidth: 150 },
                hidden: filter('Action')?.hidden ?? false,
                columnOrder: filter('Action')?.tableData?.columnOrder,
                sorting: false,
                export: false,
                render: rowData => {
                    return createAction(rowData.Type, rowData.ProductID, rowData?.CustomerID || null, rowData?.Customer?.Name || 'n/a', rowData.DeviceOnlineStatus ?? {})
                }
            },
            {
                title: translations["wipe_started"] || 'Wipe started', field: 'WipeStarted', filtering: false,
                hidden: filter('WipeStarted')?.hidden ?? false,
                columnOrder: filter('WipeStarted')?.tableData?.columnOrder,
                defaultFilter: query ? query?.q?.WipeStarted ?? null : filter('WipeStarted')?.tableData?.filterValue,
                defaultSort: filter('WipeStarted')?.tableData?.columnOrder ? query?.orderDirection : undefined,
                render: rowData => {
                    return getFormatWipeStarted(rowData.Components)
                }
            },
            {
                title: translations["verification_started"] || 'Verification started', field: 'VerificationStarted', filtering: false,
                hidden: filter('VerificationStarted')?.hidden ?? false,
                columnOrder: filter('VerificationStarted')?.tableData?.columnOrder,
                defaultFilter: query ? query?.q?.VerificationStarted ?? null : filter('VerificationStarted')?.tableData?.filterValue,
                defaultSort: filter('VerificationStarted')?.tableData?.columnOrder ? query?.orderDirection : undefined,
                render: rowData => {
                    return getFormatWipeStarted(rowData.Components, 'VerificationStarted')
                }
            },
            {
                title: translations["order"] || 'Order', field: 'OrderInventoryID',
                hidden: filter('OrderInventoryID')?.hidden ?? false,
                columnOrder: filter('OrderInventoryID')?.tableData?.columnOrder,
                defaultFilter: query ? query?.q?.OrderInventoryID ?? null : filter('OrderInventoryID')?.tableData?.filterValue,
                defaultSort: filter('OrderInventoryID')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return rowData.Order ? createPaletteAction(rowData, 'Order', rowData?.CustomerID || null, rowData?.Customer?.Name || 'n/a') : 'n/a'
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["transport_colli"] || 'Transport colli', field: 'TransportColliInventoryID',
                hidden: filter('TransportColliInventoryID')?.hidden ?? false,
                columnOrder: filter('TransportColliInventoryID')?.tableData?.columnOrder,
                defaultFilter: query ? query?.q?.TransportColliInventoryID ?? null : filter('TransportColliInventoryID')?.tableData?.filterValue,
                defaultSort: filter('TransportColliInventoryID')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return rowData.TransportColli ? createPaletteAction(rowData, 'TransportColli', rowData?.CustomerID || null, rowData?.Customer?.Name || 'n/a') : 'n/a'
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["colli"] || 'Colli', field: 'ColliInventoryID',
                hidden: filter('ColliInventoryID')?.hidden ?? false,
                columnOrder: filter('ColliInventoryID')?.tableData?.columnOrder,
                defaultFilter: query ? query?.q?.ColliInventoryID ?? null : filter('ColliInventoryID')?.tableData?.filterValue,
                defaultSort: filter('ColliInventoryID')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return rowData && rowData?.Colli ? createPaletteAction(rowData, 'Colli', rowData?.CustomerID || null, rowData?.Customer?.Name || 'n/a') : 'n/a'
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["inventory_id"] || 'Securaze ID', field: 'InventoryID',
                hidden: filter('InventoryID')?.hidden ?? false,
                columnOrder: filter('InventoryID')?.tableData?.columnOrder,
                defaultFilter: query ? query?.q?.InventoryID ?? null : filter('InventoryID')?.tableData?.filterValue,
                // defaultSort: filter('InventoryID')?.columnOrder ? query?.orderDirection : undefined,
                defaultSort: filter('InventoryID')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return rowData.InventoryID ? createPaletteActionForProduct(rowData.InventoryID, rowData.Type, classes, rowData?.CustomerID || null, rowData?.Customer?.Name || 'n/a') : 'n/a'
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["vendor"] || 'Vendor', field: 'Vendor',
                hidden: filter('Vendor')?.hidden ?? false,
                columnOrder: filter('Vendor')?.tableData.columnOrder,
                defaultFilter: query ? query?.q?.Vendor ?? null : filter('Vendor')?.tableData.filterValue,
                defaultSort: filter('Vendor')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return <Typography key={rowData.ProductID} style={{ fontSize: 12 }}
                        gutterBottom>{rowData.Vendor}</Typography>
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["external_id"] || "External ID", field: 'ExternalID',
                hidden: filter('ExternalID')?.hidden ?? false,
                columnOrder: filter('ExternalID')?.tableData.columnOrder,
                defaultFilter: query ? query?.q?.ExternalID ?? null : filter('ExternalID')?.tableData.filterValue,
                defaultSort: filter('ExternalID')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return <Typography key={rowData.ProductID} style={{ fontSize: 12 }}
                        gutterBottom>{rowData?.ProductExternalInfo?.ExternalID ?? (translations['short_not_assigned'] || 'n/a')}</Typography>
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["serial_imei"] || 'Serial Number / IMEI', field: 'SerialNumber', cellStyle: { minWidth: 250, maxWidth: 250 },
                hidden: filter('SerialNumber')?.hidden ?? false,
                columnOrder: filter('SerialNumber')?.tableData?.columnOrder,
                defaultFilter: query ? query?.q?.SerialNumber ?? null : filter('SerialNumber')?.tableData?.filterValue,
                defaultSort: filter('SerialNumber')?.tableData?.columnOrder === tableRef?.current?.state?.orderBy ? tableRef?.current?.state?.orderDirection : undefined,
                render: rowData => {
                    return imeisAndSerialNumber(rowData, translations);
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["model"] || 'Model', field: 'Model', cellStyle: { minWidth: 250, maxWidth: 250 },
                hidden: filter('Model')?.hidden ?? false,
                sorting: false,      
                columnOrder: filter('Model')?.tableData?.columnOrder,
                defaultFilter: query ? query?.q?.Model ?? null : filter('Model')?.tableData?.filterValue,
                defaultSort: filter('Model')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return <Typography key={`${rowData.ProductID}_model`} style={{ fontSize: 12 }}
                        gutterBottom>{getModel(rowData)}</Typography>
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["type"] || 'Type', field: 'ProductType',
                hidden: filter('ProductType')?.hidden ?? false,
                columnOrder: filter('ProductType')?.tableData?.columnOrder,
                lookup: productTypeLookup,
                defaultFilter: query ? query?.q?.ProductType ?? null : filter('ProductType')?.tableData?.filterValue,
                defaultSort: filter('ProductType')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return <Typography key={`${rowData.ProductID}_type`} style={{ fontSize: 12 }}
                        gutterBottom>{`${rowData?.Type}${rowData?.RemoteErasure ? ' - Remote' : ''}`}</Typography>
                }
            },
            {
                title: translations["smart_overall"] || 'SMART Overall', field: 'OverallState',
                filtering: false,
                sorting: false,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData?.Components && rowData?.Components[0]?.StorageComponents && rowData.Components[0]?.StorageComponents[0]?.OverallState ? rowData.Components[0].StorageComponents[0].OverallState : translations['short_not_assigned'] || 'n/a'}</Typography>;
                },
            },
            {
                title: translations["wipe_status"] || 'Wipe status', field: 'WipeStatus',
                cellStyle: { minWidth: 100, maxWidth: 100 },
                hidden: filter('WipeStatus')?.hidden ?? false,
                columnOrder: filter('WipeStatus')?.columnOrder,
                lookup: wipeStatusLookup,
                defaultFilter: query ? query?.q?.WipeStatus ?? null : filter('WipeStatus')?.tableData?.filterValue,
                defaultSort: filter('WipeStatus')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return getStorageComponentData(rowData?.Components, 'WipeStatus');
                }
            },
            {
                title: translations["verification_status"] || 'Verification status', field: 'VerificationStatus',
                cellStyle: { minWidth: 100, maxWidth: 100 },
                hidden: filter('VerificationStatus')?.hidden ?? false,
                columnOrder: filter('VerificationStatus')?.columnOrder,
                lookup: verificationStatusLookup,
                defaultFilter: query ? query?.q?.VerificationStatus ?? null : filter('VerificationStatus')?.tableData?.filterValue,
                defaultSort: filter('VerificationStatus')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? direction : undefined,
                render: rowData => {
                    return getStorageComponentData(rowData?.Components, 'VerificationStatus');
                }
            },
            {
                title: translations["securaze_standard"] || 'Securaze Standard', field: 'WipeMethod',
                hidden: filter('WipeMethod')?.hidden ?? false,
                columnOrder: filter('WipeMethod')?.tableData?.columnOrder,
                filtering: false,
                sorting: false,
                render: rowData => {
                    return getSecurazeStandard(rowData);
                }
            },
            {
                title: translations["securaze_solution"] || 'Securaze Solution', field: 'SecurazeSolution',
                hidden: filter('SecurazeSolution')?.hidden ?? false,
                columnOrder: filter('SecurazeSolution')?.tableData?.columnOrder,
                filtering: false,
                sorting: false,
                render: rowData => {
                    return <Typography variant={'caption'}>{getSecurazeSolution(rowData)}</Typography>;
                }
            },
            {
                title: translations["notes"] || 'Notes', field: 'Notes',
                hidden: filter('Notes')?.hidden ?? false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Notes ?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["inventory_number"] || 'Inventory number', field: 'InventoryNumber',
                hidden: filter('InventoryNumber')?.hidden ?? false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.InventoryNumber ?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
                },
                filterComponent: ({ columnDef, onFilterChanged }) => customFilter({ columnDef, onFilterChanged })
            },
            {
                title: translations["group"] || 'Group', field: 'GroupID',
                cellStyle: { minWidth: 100, maxWidth: 100 },
                hidden: filter('GroupID')?.hidden ?? false,
                columnOrder: filter('GroupID')?.tableData?.columnOrder,
                lookup: groupsLookup,
                defaultFilter: Object.keys(groupsLookup),
                defaultSort: filter('GroupID')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? tableRef?.current?.state?.orderDirection : undefined,
                render: rowData => {
                    return <Typography style={{ fontSize: 12 }} gutterBottom>{rowData?.Group?.Name ?? (translations['short_not_assigned'] || 'n/a')}</Typography>
                }
            },
        ].sort((a, b) => a.columnOrder - b.columnOrder);
    }, [classes, createAction, query, productTypeLookup, wipeStatusLookup, verificationStatusLookup, createPaletteActionForProduct, tableRef, translations, createPaletteAction, getStorageComponentData, groupsLookup]);

    tableColumns = hasPermission(permissions, 'group_list') ? tableColumns : tableColumns.filter((column) => column.field !== "GroupID");

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'all_assets_view') ?
                <ProductOverviewList filterValues={filterValues} focusedInputRef={focusedInputRef} groupsLookup={groupsLookup} groups={groups} hideViewSelector={hideViewSelector} allQuery={query} setQuery={setQuery} currentView={currentView} updateView={updateView} tableColumns={tableColumns} tableRef={tableRef} method={method} redirectOptions={redirectOptions} />
                : null}
        </div >
    );
};

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        translations: state?.translate?.translations?.activeTranslations || {}
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(ProductsAll));
